<template>
  <div class="scene-container">
    <!-- <ClipSpinner
      v-if="contentLoading"
      color="#93c5fd"
      size="50px"
      class="loader"
    /> -->

    <button
      v-if="audioObj"
      class="absolute top-3 left-3 p-3 rounded-full"
      id="btnAudioPlay"
      @click="audioPlay"
      style="z-index: 9999"
    >
      <font-awesome-icon v-if="isAudioPlay" :icon="['fas', 'volume-high']" />
      <font-awesome-icon v-else :icon="['fas', 'volume-xmark']" />
    </button>
    <button
      v-if="musicObj"
      class="bg-gray-200 absolute top-16 left-6 p-3 rounded-full"
      id="btnMusicPlay"
      @click="musicPlay"
      style="z-index: 9999"
    >
      <font-awesome-icon v-if="isMusicPlay" :icon="['fas', 'stop']" />
      <font-awesome-icon v-else :icon="['fas', 'play']" />
    </button>

    <iframe id="scene" ref="scene" :src="src" @load="onLoad()"></iframe>
    <Description
      v-if="type != 'webcam'"
      :item="item"
      :name="name"
      :locale="locale"
    />
    <div v-if="isMusic" class="music_container"></div>
    <div v-if="isAudio" class="audio_container"></div>
    <button
      v-if="this.type != 'guide'"
      class="absolute top-3 right-3 p-3 rounded-full"
      @click="onClose"
    >
      <img src="../assets/images/close_btn.png" alt="close" class="w-6" />
    </button>
    <span
      v-if="item?.message && type == 'relic'"
      class="toast"
      :class="{ active: isActive }"
    >
      {{ item.message }}
    </span>
    <button
      v-if="type == 'relic' && item.arUse == 'Y'"
      class="save_btn"
      @click="clickEvent('save')"
    >
      도감 저장
    </button>
    <button
      v-if="type == 'guide'"
      class="save_btn"
      @click="clickEvent('start')"
    >
      시작하기
    </button>
    <!-- <button class="btn" @click.prevent.stop="clickEvent()">
      Event Click Parent to Child
    </button> -->
  </div>
</template>

<script>
import Description from "../components/Description.vue";
// import ClipSpinner from "vue-spinner/src/ClipLoader.vue";
export default {
  components: {
    Description,
    // ClipSpinner,
  },
  props: {
    type: {
      type: String,
      default: "relic",
    },
    item: {
      type: Object,
      default: () => {},
    },
    name: {
      type: Object,
      default: () => {},
    },
    locale: {
      type: Object,
      default: () => {},
    },
    isRelicsSave: {
      type: Boolean,
      default: true,
    },    
    isAudio: {
      type: Boolean,
      default: false,
    },
    isMusic: {
      type: Boolean,
      default: false,
    },
    audio: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      src: "",
      audioSrc: "",
      musicSrc: "",
      isActive: true,
      scale: 0,
      rotation: { x: 90, y: 45, z: 0 },
      baseApiUrl: process.env.VUE_APP_BASE_API_URL,
      // contentLoading: true,
      audioObj: null,
      musicObj: null,
      isAudioPlay: false,
      isMusicPlay: false,
    };
  },
  computed: {},
  created() {
    this.$store.commit("saveIsVideo", false);
  },
  mounted() {
    if (this.name?.ko == "희령군 어사금") {
      this.scale = 0.0045;
    } else if (this.name?.ko == "윤탕신 목패") {
      this.scale = 0.004;
    } else if (this.name?.ko == "유엽배") {
      this.scale = 0.0035;
    } else if (this.name?.ko == "주먹도끼") {
      this.scale = 0.0008;
    } else if (
      this.name?.ko == "권욱 도와 검" ||
      this.name?.ko == "우리나라 최초의 백과사전"
    ) {
      this.scale = 0.0011;
    } else if (this.name?.ko == "용문사 대장전과 윤장대") {
      this.scale = 0.002;
    } else if (this.name?.ko == "예천반닫이") {
      this.scale = 0.0015;
    }

    window.addEventListener("message", this.receiveMessage);
    if (this.type == "webcam") {
      this.src = "/webcam.html";
    } else if (
      this.item.arUse == "Y" &&
      !this.item.model &&
      !this.item.cnModel
    ) {
      this.src = "/image.html";
    } else {
      this.src = "/scene.html";
    }
    this.getAudioSrc();
    if (this.item?.message) {
      setTimeout(() => {
        this.isActive = false;
      }, 3000);
    }
    // setTimeout(() => {
    //   this.contentLoading = false;
    // }, 3000);
  },
  unmounted() {
    if (this.audioObj) {
      this.isAudioPlay = false;
      this.audioObj.pause();
      this.audioObj = null;
    }
    if (this.musicObj) {
      this.isMusicPlay = false;
      this.musicObj.pause();
      this.musicObj = null;
    }

    window.removeEventListener("message", this.receiveMessage);
  },
  methods: {
    clickEvent(type) {
      if (type == "save") {
        if (window.confirm("도감에 저장하시겠습니까?")) {
          this.$router.push({
            name: "Album",
            params: { relicId: this.$route.params.id },
          });
        }
      } else if (type == "start") {
        this.$router.push({ name: "Antiquity", params: { reload: true } });
      }
    },
    async receiveMessage(e) {
      let data = e.data;
      console.log("Event Click Child to Parent");
      console.log(data);
    },
    onLoad() {
      if (this.item) {
        if (this.type != "webcam") {
          let model = `${this.baseApiUrl}/api/files/load/${this.item.model}`;
          if (this.$i18n.locale == "zh" && this.item.cnModel) {
            model = `${this.baseApiUrl}/api/files/load/${this.item.cnModel}`;
          }
          if (this.$refs.scene) {
            this.$refs.scene.contentWindow.postMessage(
              {
                type: this.type,
                data: {
                  model: model,
                  scale: this.scale,
                  rotation:
                    this.name?.ko == "예천다식판"
                      ? "예천다식판"
                      : this.name?.ko == "희령군 어사금"
                      ? "희령군 어사금"
                      : this.name?.ko == "안내"
                      ? "안내"
                      : this.name?.ko == "용문사 대장전과 윤장대"
                      ? "용문사 대장전과 윤장대"
                      : this.name?.ko == "예천반닫이"
                      ? "예천반닫이"
                      : this.item.arUse == "N"
                      ? "noAR"
                      : "",
                  image: `${this.baseApiUrl}/api/files/load/${this.item.image}`,
                },
              },
              "*"
            );
          }
        }
      }
    },
    onClose() {
      if (this.type == "album") {
        this.$router.push({ name: "Album" });
      } else {
        this.$router.push({ name: "Antiquity", params: { reload: true } });
      }
    },
    audioPlay(play = false) {
      if (0 < this.audioSrc.length) {
        if (this.audioObj == null) {
          this.audioObj = new Audio(
            `${this.baseApiUrl}/api/files/load/${this.audioSrc}`
          );
        }

        if (play) {
          if (!this.audioObj.paused) {
            this.isAudioPlay = false;
            this.audioObj.pause();
          } else {
            this.isAudioPlay = true;
            this.audioObj.play();
          }

          if (!this.audioObj.paused) {
            this.isAudioPlay = true;
          } else {
            this.isAudioPlay = false;
          }
        }
      }
    },
    musicPlay(play = false) {
      if (0 < this.musicSrc.length) {
        if (this.musicObj == null) {
          this.musicObj = new Audio(
            `${this.baseApiUrl}/api/files/load/${this.musicSrc}`
          );
        }

        if (play) {
          if (!this.musicObj.paused) {
            this.isMusicPlay = false;
            this.musicObj.pause();
          } else {
            this.isMusicPlay = true;
            this.musicObj.play();
          }

          if (!this.musicObj.paused) {
            this.isMusicPlay = true;
          } else {
            this.isMusicPlay = false;
          }
        }
      }
    },
    getAudioSrc() {
      if (this.isAudio) {
        if (this.$i18n.locale == "en" && this.audio.en) {
          this.audioSrc = this.audio.en;
        } else if (this.$i18n.locale == "zh" && this.audio.zh) {
          this.audioSrc = this.audio.zh;
        } else if (this.$i18n.locale == "ja" && this.audio.ja) {
          this.audioSrc = this.audio.ja;
        } else if (this.$i18n.locale == "child" && this.audio.child) {
          this.audioSrc = this.audio.child;
        } else {
          this.audioSrc = this.audio.ko;
        }
      }
      if (this.isMusic) {
        this.musicSrc = this.item.music;
      }

      setTimeout(() => {
        this.audioPlay(true);
        this.musicPlay(true);
      }, 1000);
    },
  },
};
</script>

<style scoped>
.btn {
  position: absolute;
  background-color: #000;
  padding: 10px;
  color: #fff;
}

.scene-container {
  position: absolute;
  width: 100%;
  height: 100%;
}

#scene {
  position: absolute;
  width: 100%;
  height: 100%;
}
.audio_container,
.music_container {
  position: absolute;
  top: 1rem;
  width: 30vw;
  font-size: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.audio_container {
  left: 50%;
  transform: translateX(-50%);
}
.music_container {
  left: 1rem;
}
#music,
#audio {
  width: 100%;
  height: 100%;
  position: static;
  height: 2rem;
}
audio::-webkit-media-controls-panel {
  background-color: rgba(0, 0, 0, 0.1);
}
.toast {
  visibility: hidden;
  padding: 0.5rem 1rem;
  background-color: #93c5fd;
  position: fixed;
  bottom: 5rem;
  left: 0.5rem;
  border-radius: 2px;
  z-index: 99;
}
.toast.active {
  visibility: visible;
  -webkit-animation: fadein 0.5s, fadeout 0.5s 2.5s;
  animation: fadein 0.5s, fadeout 0.5s 2.5s;
}
@-webkit-keyframes fadein {
  from {
    bottom: 4rem;
    opacity: 0;
  }
  to {
    bottom: 5rem;
    opacity: 1;
  }
}

@keyframes fadein {
  from {
    bottom: 4rem;
    opacity: 0;
  }
  to {
    bottom: 5rem;
    opacity: 1;
  }
}

@-webkit-keyframes fadeout {
  from {
    bottom: 5rem;
    opacity: 1;
  }
  to {
    bottom: 4rem;
    opacity: 0;
  }
}

@keyframes fadeout {
  from {
    bottom: 5rem;
    opacity: 1;
  }
  to {
    bottom: 4rem;
    opacity: 0;
  }
}
.save_btn {
  position: absolute;
  background-color: #c3c3c3;
  padding: 10px;
  color: #3c2515;
  border: none;
  border-radius: 1.5rem;
  border-style: solid;
  border-width: 1px;
  border-color: #ffffff;
  outline: none;
  font-size: 1rem;
  font-weight: 500;
  left: 50%;
  top: 70%;
  transform: translateX(-50%);
  z-index: 9;
  width: 190px;
}
.loader {
  position: absolute;
  top: 30%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
